import { render, staticRenderFns } from "./sellers.page.vue?vue&type=template&id=54c2de15&scoped=true"
import script from "./sellers.page.vue?vue&type=script&lang=js"
export * from "./sellers.page.vue?vue&type=script&lang=js"
import style0 from "./sellers.page.vue?vue&type=style&index=0&id=54c2de15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2de15",
  null
  
)

export default component.exports